import {Route} from '@angular/router';
import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';
import {LayoutComponent} from 'app/layout/layout.component';
import {InitialDataResolver} from 'app/app.resolvers';
import {RoleGuard} from './core/auth/guards/role.guard';
import {UsersComponent} from './modules/users/users.component';
import {DossierInterventionComponent} from './modules/dossier-intervention/dossier-intervention.component';
import {EquipementComponent} from './modules/equipement/equipement.component';
import {CalendrierComponent} from './modules/calendrier/calendrier.component';
import {
    EditFicheInterventionComponent
} from './modules/dossier-intervention/fiche-intervention/edit-fiche-intervention/edit-fiche-intervention.component';
import {PermissionComponent} from './modules/permission/permission.component';
import {CroquisComponent} from './modules/croquis/croquis.component';
import {ConfirmNavigationGuard} from './shared/ConfirmNavigationGuard.guard';
import {DossierInterventionIdComponent} from './modules/dossier-intervention/id/dossier-intervention-id.component';
//Import dynamique

export const appRoutes: Route[] = [

    // Redirect empty path to '/dashboard'
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dossiers-interventions'
    },
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'dashboard'
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'connexion',
                loadChildren: () => import('app/modules/auth/connexion/connexion.module').then(m => m.AuthSignInModule)
            },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {
                path: 'deconnexion',
                loadChildren: () => import('app/modules/auth/deconnexion/deconnexion.module').then(m => m.AuthSignOutModule)
            },
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                pathMatch: 'full',
                redirectTo: 'dossiers-interventions'
            },
            {
                path: 'calendrier',
                component: CalendrierComponent,
                canActivate: [RoleGuard],
                data: {
                    title: 'Calendrier',
                }
            },
            {
                path: 'dossiers-interventions',
                component: DossierInterventionComponent,
                canActivate: [RoleGuard],
                canDeactivate: [ConfirmNavigationGuard],
                data: {
                    title: 'Dossiers d\'intervention'
                },
            },
            {
                path: 'dossiers-interventions/:idDossierIntervention',
                component: DossierInterventionIdComponent,
                canDeactivate: [ConfirmNavigationGuard],
                data: {
                    title: 'Dossiers d\'intervention'
                },
            },
            {
                path: 'dossiers-interventions/:idDossierIntervention/fiches-interventions',
                component: DossierInterventionIdComponent,
                canDeactivate: [ConfirmNavigationGuard],
                data: {
                    title: 'Dossiers d\'intervention',
                    tabIndex: 'fiches-interventions'
                },
            },
            {
                path: 'dossiers-interventions/:idDossierIntervention/fiches-interventions/:idFicheIntervention',
                component: EditFicheInterventionComponent,
                canDeactivate: [ConfirmNavigationGuard],
            },

            {
                path: 'dossiers-interventions/:idDossierIntervention/croquis/:idEtage',
                canActivate: [RoleGuard],
                component: CroquisComponent,
                data: {
                    title: 'Croquis'
                }
            },
            {
                path: 'equipements',
                component: EquipementComponent,
                canActivate: [RoleGuard],
                canDeactivate: [ConfirmNavigationGuard],
                data: {
                    title: 'Équipements',
                }
            },
            {
                path: 'utilisateurs',
                component: UsersComponent,
                canActivate: [RoleGuard],
                canDeactivate: [ConfirmNavigationGuard],
                data: {
                    title: 'Utilisateurs',
                }
            },
            {
                path: 'permissions',
                component: PermissionComponent,
                canActivate: [RoleGuard],
                data: {
                    title: 'Permissions',
                }
            },
            //Ajout de route dynamique
        ]
    }
];
